import React from 'react';
import PropTypes from 'prop-types';

// assets
import iconErrorValidation from '../../../assets/img/icon-error.svg';
import StyledValidationMessage from './styles';

const iconsForValitacion = {
  error: iconErrorValidation,
}
const ValidationMessage = (props) => {
  const { customStyles, type, message } = props;

  return (
    <StyledValidationMessage customStyles={customStyles}>
      {iconsForValitacion[type] && (
        <img src={iconsForValitacion[type]} alt={`icon ${type} validation`} />
      )}
      <p className={`text-color-${type}`}>{message}</p>
    </StyledValidationMessage>
  );
};

ValidationMessage.defaultProps = {
  type: '',
  message: '',
  customStyles: ''
};
ValidationMessage.propTypes = {
  type: PropTypes.string,
  message: PropTypes.string,
  customStyles: PropTypes.string
};

export default ValidationMessage;
